import {post} from "../Api";
import Order from "./models/Order";

export default function PostOrder(order) {
    if (!(order instanceof Order)) {
        throw new Error("Order must be of type Order, not : " + typeof order);
    }

    return post('orders', order);
}